<template>
	<div class="row">
		<div class="col-sm-4">
			<label><b>Pilih Supplier</b></label>
		</div>
		<div class="col-sm-8">
			<multiselect v-model="selectedSupplier" class="orders-status-list multiselect-auto-width form-control"
				placeholder="Select Supplier (Name - Business Name - Code)" :custom-label="supplierLabel" track-by="email"
				:options="supplierOptions" :show-labels="false" :allow-empty="false" :multiple="false"
				:class="{ 'multiselect-invalid': isError }" @select="onSupplierChange" :disabled="isEdit">
				<span slot="noResult">{{ $t('No Supplier found') }}</span>
			</multiselect>
			<small v-if="isError" class="text-danger">Supplier cannot be empty</small>
		</div>
	</div>
</template>

<script>
import userApi from '@/api/user';
import { duplicateVar, getAxiosErrorMessage } from '@/lib/helper';

export default {
	props: {
		isError: {
			type: Boolean,
			default: () => false,
		},
		isEdit: {
			type: Boolean,
			default: () => false,
		},
		product: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			selectedSupplier: null,
			suppliers: [],
		};
	},
	methods: {
		supplierLabel({ name, businessName, code }) {
			return `${name} - ${businessName} - ${code}`;
		},
		fetchSuppliers() {
			const params = {
				limit: 1000,
				sort_by: 'created_at',
				sort: 'desc',
				page: 1,
				keyword: '',
				role: 'owner',
				owner_type: 'supplier', // supplier
			};

			const callback = (response) => {
				let suppliers = response.data;

				if (suppliers.length > 0) {
					suppliers = suppliers.map((data) => {
						const newObj = {
							...data,
						};
						newObj.businessName = data.store?.name || '';
						newObj.code = data?.code || '';
						return newObj;
					});
				}

				this.suppliers = suppliers;

				if (this.product && this.product.user_id) {
					this.setSelectedSupplier(this.product.user_id);
				}
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				this.$notify({
					group: 'productCreator',
					title: 'Fetch Suppliers',
					text: msg,
					type: 'error',
				});
			};
			userApi.getUsersMinimal(params, callback, errorCallback);
		},
		onSupplierChange(supplier) {
			this.$emit('change', supplier);
		},
		setSelectedSupplier(userId) {
			if (this.suppliers.length > 0) {
				const selectedSupplier = this.suppliers.find(supplier => supplier._id === userId);
				this.selectedSupplier = selectedSupplier;
				this.onSupplierChange(this.selectedSupplier);
			}
		},
	},
	computed: {
		supplierOptions() {
			const options = duplicateVar(this.suppliers);
			return options;
		},
	},
	watch: {
		product(prod) {
			if (prod && prod.user_id) {
				this.setSelectedSupplier(prod.user_id);
			}
		},
	},
	mounted() {
		this.fetchSuppliers();
	},
};
</script>

<style scoped>
.multiselect-invalid {
	.multiselect__tags {
		border-color: #ed1c24;
	}
}
</style>
